import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';
import { useTheme } from '@mui/styles';
import { useMediaQuery } from '@mui/material';

export const FinishedStep = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#6C2AD2" />
      <path
        d="M8 12.9167L10.9167 15.8333L16.75 10"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const WaitingStep = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#E6F2FF" />
    </svg>
  );
};

const CustomStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  zIndex: 1,
  width: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
}));

function CustomStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: completed ? <FinishedStep /> : <WaitingStep />,
    2: completed ? <FinishedStep /> : <WaitingStep />,
    3: completed ? <FinishedStep /> : <WaitingStep />,
  };
  return (
    <CustomStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </CustomStepIconRoot>
  );
}

export default function CustomizedSteppers({ stepValue, requestEsign }) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    width: '100%',
    marginLeft: '-10px',
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: matchessm ? 10 : 14,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: '#6C2AD2',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: '#6C2AD2',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 1.4,
      border: 0,
      backgroundColor: '#ffff',
    },
  }));
  const steps = requestEsign
    ? ['Preparing Contract', 'Sign Pending', 'Contract Signed']
    : ['Agent Preparing', 'Your Signature', 'Exchanged'];

  // function CustomStepTicIcon(props) {
  //   const { active, completed, className } = props;

  //   const icons = {
  //     1: stepValue == "1" ? <WaitingStep /> : completed ? <FinishedStep /> : <WaitingStep />,
  //     2: stepValue == "2" ? <WaitingStep /> : completed ? <FinishedStep /> : <WaitingStep />,
  //     3: stepValue == "3" ? <WaitingStep /> : completed ? <FinishedStep /> : <WaitingStep />,
  //   };
  //   return (
  //     <CustomStepIconRoot
  //       ownerState={{ completed, active }}
  //       className={className}
  //     >
  //       {icons[String(props.icon)]}
  //     </CustomStepIconRoot>
  //   );
  // }
  function CustomStepTicIcon(props) {
    const { active, completed, className, icon } = props;
    const stepNum = Number(icon);
    const currentStep = Number(stepValue);

    let iconToShow = null;

    if (stepNum < currentStep) {
      iconToShow = <FinishedStep />; // completed — show tick
    } else if (stepNum === currentStep) {
      iconToShow = null; // current — purple filled, no icon
    } else {
      iconToShow = null; // future — empty white circle
    }

    return (
      <CustomStepIconRoot
        ownerState={{ completed: stepNum < currentStep, active }}
        className={className}
        sx={{
          backgroundColor:
            stepNum < currentStep
              ? '#7C3AED' // ticked step background
              : stepNum === currentStep
              ? '#7C3AED' // current step purple background
              : '#E0E0E0', // future step (gray/white)
          color: '#fff',
          width: matchessm ? 20 : 32,
          height: matchessm ? 20 : 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {iconToShow}
      </CustomStepIconRoot>
    );
  }

  return (
    <Stack sx={{ width: '100%' }}>
      <Stepper
        alternativeLabel
        activeStep={stepValue}
        connector={<CustomConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepTicIcon}
              sx={{
                paddingBottom: matchessm ? '10px' : 'auto',
                '.MuiStepLabel-label': {
                  fontFamily: 'poppins',
                  whiteSpace: 'nowrap',
                  color: '#ffff !important',
                  fontWeight: '300 !important',
                  fontSize: '10px',
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}

export function AgentESignCustomizedSteppers({ stepValue, requestEsign }) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    width: '100%',
    marginLeft: '-10px',
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: matchessm ? 10 : 14,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: '#6C2AD2',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: '#6C2AD2',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 1.4,
      border: 0,
      backgroundColor: '#ffff',
    },
  }));
  const steps = requestEsign
    ? ['Preparing Contract', 'Sign Pending', 'Contract Signed']
    : ['Agent Preparing', 'Your Signature', 'Exchanged'];

  function CustomStepTicIcon(props) {
    const { active, completed, className, icon } = props;
    const stepNum = Number(icon);
    const currentStep = Number(stepValue);

    let iconToShow = null;

    if (stepNum < currentStep) {
      iconToShow = <FinishedStep />; // completed — show tick
    } else if (stepNum === currentStep) {
      iconToShow = null; // current — purple filled, no icon
    } else {
      iconToShow = null; // future — empty white circle
    }

    return (
      <CustomStepIconRoot
        ownerState={{ completed: stepNum < currentStep, active }}
        className={className}
        sx={{
          backgroundColor:
            stepNum < currentStep
              ? '#7C3AED' // ticked step background
              : stepNum === currentStep
              ? '#7C3AED' // current step purple background
              : '#E0E0E0', // future step (gray/white)
          color: '#fff',
          width: 32,
          height: 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {iconToShow}
      </CustomStepIconRoot>
    );
  }

  return (
    <Stack sx={{ width: '100%' }}>
      <Stepper
        alternativeLabel
        activeStep={stepValue}
        connector={<CustomConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepTicIcon}
              sx={{
                paddingBottom: matchessm ? '10px' : 'auto',
                '.MuiStepLabel-label': {
                  fontFamily: 'poppins',
                  whiteSpace: 'nowrap',
                  color: '#ffff !important',
                  fontWeight: '300 !important',
                  fontSize: '10px',
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}

const signRequestSteps = ['Agent Preparing', 'Your Signature', 'Exchanged'];
export const ESignRequestCustomStepper = ({ stepValue }) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const CustomConnector = styled(StepConnector, {
    shouldForwardProp: (prop) => prop !== 'currentStep',
  })(({ currentStep }) => ({
    width: '100%',
    marginLeft: '-10px',
    [`& .${stepConnectorClasses.line}`]: {
      height: 1.4,
      border: 0,
      backgroundColor: '#fff',
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
      backgroundColor: '#6C2AD2',
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
      backgroundColor: currentStep > 1 ? '#6C2AD2' : '#fff',
    },
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: matchessm ? 10 : 14,
    },
  }));
  function CustomStepTicIcon(props) {
    const { active, completed, className } = props;

    const icons = {
      1:
        stepValue == '1' ? (
          <WaitingStep />
        ) : completed ? (
          <FinishedStep />
        ) : (
          <WaitingStep />
        ),
      2:
        stepValue == '2' ? (
          <WaitingStep />
        ) : completed ? (
          <FinishedStep />
        ) : (
          <WaitingStep />
        ),
      3:
        stepValue == '3' ? (
          <WaitingStep />
        ) : completed ? (
          <FinishedStep />
        ) : (
          <WaitingStep />
        ),
    };
    return (
      <CustomStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {icons[String(props.icon)]}
      </CustomStepIconRoot>
    );
  }

  return (
    <Stack sx={{ width: '100%' }}>
      <Stepper
        alternativeLabel
        activeStep={stepValue}
        connector={<CustomConnector />}
      >
        {signRequestSteps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepTicIcon}
              sx={{
                paddingBottom: matchessm ? '10px' : 'auto',
                '.MuiStepLabel-label': {
                  fontFamily: 'poppins',
                  whiteSpace: 'nowrap',
                  color: '#ffff !important',
                  fontWeight: '300 !important',
                  fontSize: '10px',
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
};

const signPostWinnerSteps = [
  'Buyer Contract',
  'Vendor Contract',
  'Deposit',
  'Exchanged',
];
export function AgentPostWinnerStepper({ stepValue, completedSteps }) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  /* Responsive sizes */
  const ICON_SIZE = matchessm ? 22 : 28;
  const LABEL_MAX_WIDTH = matchessm ? 70 : 100;
  const ROW_GAP = matchessm ? 8 : 12;

  const steps = [
    'Buyer Contract',
    'Vendor Contract',
    'Deposit',
    'Exchanged',
  ];

  /* Build grid columns dynamically */
  const gridTemplateColumns = steps
    .map((_, i) =>
      i === steps.length - 1
        ? `${ICON_SIZE}px`
        : `${ICON_SIZE}px 1fr`
    )
    .join(' ');

  return (
    <div
      style={{
        width: '100%',
        padding: matchessm ? '0 8px' : '0 16px',
        display: 'grid',
        gridTemplateColumns,
        rowGap: ROW_GAP,
        alignItems: 'center',
      }}
    >
      {/* ================= ICONS + CONNECTORS ================= */}
      {steps.map((_, index) => {
        const isCompleted = completedSteps.includes(index);
        const isLast = index === steps.length - 1;
        const isConnectorActive =
          completedSteps.includes(index) &&
          completedSteps.includes(index + 1);

        return (
          <React.Fragment key={`icon-${index}`}>
            {/* ICON */}
            <div
              style={{
                width: ICON_SIZE,
                height: ICON_SIZE,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gridRow: 1,
                gridColumn: index * 2 + 1,
                zIndex: 1,
              }}
            >
              {isCompleted ? <FinishedStep /> : <WaitingStep />}
            </div>

            {/* CONNECTOR */}
            {!isLast && (
              <div
                style={{
                  height: matchessm ? 2 : 3,
                  backgroundColor: isConnectorActive
                    ? '#6C2AD2'
                    : '#ccc',
                  gridRow: 1,
                  gridColumn: index * 2 + 2,
                }}
              />
            )}
          </React.Fragment>
        );
      })}

      {/* ================= LABELS ================= */}
      {steps.map((label, index) => (
        <div
          key={`label-${index}`}
          style={{
            gridRow: 2,
            gridColumn: index * 2 + 1,
            maxWidth: LABEL_MAX_WIDTH,
            justifySelf: 'center',
            textAlign: 'center',
            fontFamily: 'Poppins',
            fontSize: matchessm ? '9px' : '10px',
            fontWeight: 300,
            color: '#666666',
            whiteSpace: 'normal',
            lineHeight: 1.2,
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
}
